import { uri } from '../../api-endpoint';
import {
  IAnnotationAPIValidationError,
  IAnnotationFromAPISuccessResponse
} from '../../type-conversion/annotation/from-api-repsonse';
import { AnnotationAPIRequestBody } from '../../type-conversion/annotation/to-api-request-body';
import { updateTemplateFn } from '../common';

export const updateProjectImageAnnotation = (token: string) => (
  projectId: number,
  imageId: number,
  annotationUuid: string
) =>
  updateTemplateFn(
    token,
    uri.projectImageAnnotationById(projectId, imageId, annotationUuid),
    AnnotationAPIRequestBody,
    IAnnotationFromAPISuccessResponse,
    IAnnotationAPIValidationError
  );
